<template>
  <b-container class="mt-4">
    <b-row align-h="center">
      <b-col md="9" class="pb-4">
        <b-button class="menuButton" to="sendmail" size="lg" :block="true">
          <div><b-icon-envelope class="mr-4"/><span>メール送信</span></div>
          <small class="d-none d-md-inline">メンバーに質問メールを送信します</small>
        </b-button>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col md="9" class="pb-4">
        <b-button class="menuButton" to="responses" size="lg" :block="true">
          <div><b-icon-card-checklist class="mr-4"/><span>回答確認</span></div>
          <small class="d-none d-md-inline">メンバーからの回答を確認します</small>
        </b-button>
      </b-col>
    </b-row>
    <hr class="pb-4">
    <b-row align-h="center">
      <b-col md="9" class="pb-4">
        <b-button class="menuButton" to="templates" size="lg" :block="true">
          <div><b-icon-file-text class="mr-4"/><span>定型文一覧</span></div>
          <small class="d-none d-md-inline">送信時に選択できる定型文を追加・編集します</small>
        </b-button>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col md="9" class="pb-4">
        <b-button class="menuButton" to="users" size="lg" :block="true" v-if="isSelfMember">
          <div><b-icon-people class="mr-4"/><span>メンバー一覧</span></div>
          <small class="d-none d-md-inline">メールの送信先を追加・編集します</small>
        </b-button>
        <b-button class="menuButton" to="altusers" size="lg" :block="true" v-else>
          <div><b-icon-people class="mr-4"/><span>メンバー一覧</span></div>
          <small class="d-none d-md-inline">メールの送信先を確認します</small>
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import store from '@/store'

export default {
  name: 'Menu',
  created () {
    this.init()
  },
  watch: {
    '$route': 'init'
  },
  computed: {
    isSelfMember() {
      return this.corporationId == this.memberCorporationId
    }
  },
  methods: {
    init () {
      store.dispatch('auth/refreshUserTags', { root: true })
    }
  }
}
</script>

<style scoped>
.menuButton {
  max-width: 480px;
  margin: auto;
}
.btn {
  background-color: seagreen;
  border-radius: 4px;
  font-size: 1.5rem;
  font-weight: bold;
  letter-spacing: 0.05em;
  padding: 0.2em 0.6em;
}
.btn:active, .btn:hover {
  background-color: rgba(60,179,113,1) !important;
  border-color: honeydew;
}
.btn:hover svg {
  transition: transform .3s linear;
  transform: translateX(5px);
}
.btn span {
  display: inline-block;
  width: 12rem;
  text-align: center;
}
.btn small {
  color: honeydew;
  font-size: 1rem;
  font-weight: normal;
  position: relative;
  text-decoration: none;
}
.btn small::after {
  position: absolute;
  bottom: -3px;
  left: 0;
  content: '';
  width: 100%;
  height: 1px;
  background: honeydew;
  transform: scale(0, 1);
  transform-origin: left top;
  transition: transform .3s;
}
.btn:hover small::after {
  transform: scale(1, 1);
}

@media (min-width: 768px) {
  .btn {
    background-image: none;
  }

  .btn:hover {
    background-image: url(data:image/png;base64,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);
    background-repeat: no-repeat;
    background-position: bottom left;
    background-size: 42px 42px;
  }
}
</style>